import React from 'react';
import s from './images.module.scss'
import { PhotoProvider, PhotoView } from 'react-photo-view';
import classNames from 'classnames';

export const Images = ({images, className = ""}) => {
  return (
    <PhotoProvider>
			<div className={classNames(s.imagesWrapper, className)}>
				{images.map((src, index) => (
				<PhotoView src={ src }>
						<img
							src={ src }
							key={ index }
							alt=""
							className={s.image}
						/>
					</PhotoView>
				))}
			</div>
		</PhotoProvider>
  );
}